import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import './UserHomepage.css';
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";
import DynamicOrgHomepage from "../components/DynamicOrgHomepage.jsx";
import DynamicOrgNavbar from "../components/DynamicOrgNavbar";

const UserHomepage = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const mainDomain = "sportinghip.com";
  const hostname = window.location.hostname;
  const domainFromQuery = searchParams.get("domain");
  const domain = domainFromQuery || (hostname !== mainDomain ? hostname : null);

  const { isAuthenticated, loading: authLoading, setOrganization } = useAuth();  // ✅ Include setOrganization properly
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, authLoading, navigate]);
  const PUBLIC_PAGES = ['registration', 'leagueInfo', 'tournament', 'ourTeam', 'leagueFootage', 'youth', 'contact'];

  useEffect(() => {
    const fetchOrg = async () => {
      try {
        let res;
        if (slug && !PUBLIC_PAGES.includes(slug)) {
          res = await api.get(`/api/organizations/slug/${slug}`);
        } else if (domain) {
          const formattedDomain = domain.includes('.') ? domain : `${domain}.com`;
          res = await api.get(`/api/organizations/domain/${formattedDomain}`);
        }

        console.log("✅ Loaded org:", res?.data?.organization);

        if (res?.data?.organization) {
          setOrganization(res.data.organization);
        }
      } catch (err) {
        console.error("❌ Error fetching org:", err.response?.data || err.message);
      }
    };

    fetchOrg();
  }, [domain, slug, setOrganization]);


  if (authLoading) return null;

  return (
    <div>
      <DynamicOrgHomepage />
    </div>
  );
};

export default UserHomepage;
